import classNames from 'classnames';
import Link from 'next/link';
import React, {ReactElement} from 'react';

type Option = {
  id: string;
  label: string;
  href: string;
  disabled?: boolean;
};

type Props = {
  options: Option[];
  activeId: string; // Matches the id of the active option
  className?: string;
};

const Tab = ({option: {label, href, disabled}, active}: {option: Option; active: boolean}) => {
  const className = classNames(
    'flex items-center justify-center',
    'rounded-[10px] p-[1.4rem] text-sm text-center !no-text-shadow text-primary-800'
  );

  return active ? (
    <div className={classNames(className, 'bg-white')}>{label}</div>
  ) : disabled ? (
    <div className={classNames(className, 'italic cursor-not-allowed')}>{label}</div>
  ) : (
    <Link href={href} className={classNames('hover:bg-white', className)}>
      {label}
    </Link>
  );
};

const TabBar = ({options, activeId, className}: Props): ReactElement => {
  return (
    <div className={classNames('grid grid-flow-col auto-cols-fr bg-gray-100 rounded-[10px] p-2 gap-2', className)}>
      {options.map(option => (
        <Tab key={option.id} option={option} active={option.id === activeId} />
      ))}
    </div>
  );
};

export default TabBar;
